import { useInfiniteQuery as useInfiniteQueryBase, } from '@tanstack/react-query';
import { request } from '../../request';
export const useInfiniteQuery = (key, query, endpoint, variables) => {
    const queryKey = [key, variables];
    const results = useInfiniteQueryBase({
        queryKey,
        queryFn: async ({ pageParam = 0 }) => {
            return request({
                query,
                endpoint,
                variables: {
                    ...(variables || {}),
                    page: pageParam,
                },
            });
        },
        initialPageParam: 0,
        getPreviousPageParam: firstPage => firstPage.meta.prevPage || undefined,
        getNextPageParam: lastPage => lastPage.meta.nextPage || undefined,
    });
    return {
        queryKey,
        ...results,
    };
};
//# sourceMappingURL=useInfiniteQuery.js.map